// @ts-nocheck

import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import _ from 'lodash';

interface IPortalProps {
  children: any;
  portalRoot: HTMLElement | null;
  closeAllComments: () => void;
}

const Portal = ({ children, portalRoot, closeAllComments }: IPortalProps) => {
  const [containerEl] = useState(document.createElement('div'));
  const [root, setRoot] = useState(null);

  useEffect(() => {
    function closeAllCommentsForDoc(e: any) {
      const path = _.get(e, 'path') || (e.composedPath && e.composedPath());
      if (path) {
        const clickCameFromFeebackElement = path.find(elm =>
          _.includes(_.get(elm, 'attributes.class.value', ''), 'feedback'),
        );
        if (!clickCameFromFeebackElement) {
          closeAllComments();
        }
      }
    }
    if (portalRoot && portalRoot !== root) {
      containerEl.style = 'position: absolute; top: 0; left:0;';
      portalRoot.appendChild(containerEl);
      setRoot(portalRoot);
      portalRoot.addEventListener('click', closeAllCommentsForDoc);
    }
  }, [containerEl, portalRoot, root, closeAllComments]);

  if (!root) {
    return null;
  }
  return createPortal(children, containerEl);
};

export default Portal;
